export default {
    listagem: {
        titulo_pagina: 'Lista de Fabricantes',
        novo: 'Adicionar novo Fabricante',
        table: {
            empty: 'Nenhum Fabricante encontrado',
            nome: 'Nome',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Fabricante',
            editar: 'Editar Fabricante'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome do Fabricante'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Fabricante'
            },
            botao_salvar : 'Salvar Fabricante'
        },
        create: {
            success: 'Fabricante criado com Sucesso!',
            error: 'Error ao criar Fabricante!'
        },
        update: {
            success: 'Fabricante editado com Sucesso!',
            error: 'Error ao editar Fabricante!'
        }
    }
}
